import {observable} from 'mobx';
import {createInstance, ModelProperties} from 'utils';

import {WebPage} from './web-page';
import {Language} from './language';

export class WebPageLanguage {
    @observable pageId!: number;

    @observable languageId!: number;

    @observable enabled!: boolean;

    @observable published!: boolean;

    @observable page?: WebPage;

    @observable language?: Language;

    constructor(settings?: ModelProperties<WebPageLanguage>) {
        if (settings) {
            Object.assign(this, settings);
            this.page = createInstance(WebPage, settings.page);
            this.language = createInstance(Language, settings.language);
        }
    }
}